// extracted by mini-css-extract-plugin
export default {"container-btn-file_error":"UploadButton_container-btn-file_error__Yvjsc","container-btn-file":"UploadButton_container-btn-file__9OGZs"};